import { OneClickUnsubscribe } from "#/components/subscribe/OneClickUnsubscribe.js";
import { Toaster } from "#/components/subscribe/Toaster.js";
import { createT } from "#/lib/i18n.js";

type Props = { token: string; locale: string };

export { Page };

function Page({ token, locale }: Props) {
  const t = createT(locale, "subscribe");
  const dir = locale === "ar" ? "rtl" : "ltr";

  return (
    <>
      <main id="main-content" className="mx-auto max-w-2xl px-4 py-12">
        <OneClickUnsubscribe token={token} locale={locale} t={t} />
      </main>
      <Toaster dir={dir} />
    </>
  );
}
